



















import { Component, Prop, Vue } from 'vue-property-decorator'
import { DownloadLinkInfo } from '../../modules/class/Downloads'
import { createCustomEvent } from '../../modules/CustomEvent'
import RemoveTag from '@/components/Parts/RemoveTag.vue'

@Component({
  components: { RemoveTag }
})
export default class PdfList extends Vue {
  @Prop() private item!: DownloadLinkInfo

  /**
   * リンククリック時の動作
   */
  private linkClick(url: string) {
    if (window.iwgp?.existDlEvent) {
      // DLイベントが定義されている場合は、DLイベントを発生させる
      createCustomEvent('start-pdf-download', { url: url })
    } else {
      // DLイベントが定義されていない場合は、そのまま画面遷移させる
      window.location.href = url
    }
  }
}
